export var calculateClientsPerPage = function (clientRowHeight) {
    var header = document.querySelector('header');
    var footer = document.querySelector('footer');
    var headerHeight = (header === null || header === void 0 ? void 0 : header.getBoundingClientRect().height) || 112;
    var footerHeight = (footer === null || footer === void 0 ? void 0 : footer.getBoundingClientRect().height) || 90;
    var availableHeight = window.innerHeight - headerHeight - footerHeight;
    return Math.max(1, Math.floor(availableHeight / clientRowHeight));
};
